package com.milta.feature.route.domain.entity

/**
 * One card of the web dashboard's "Preuves de la tournée" grid (MIL-52, Screen B —
 * `GET /api/v1/routes/{routeId}/proofs`). Reuses [DeliveryOutcome] for [status] (same closed set —
 * "Completed"/"Failed" — as the MIL-41 validate-delivery flow) rather than introducing a duplicate
 * enum, per the enum-not-magic-strings rule. Distinct from [DeliveryProof] (the MIL-41 submit
 * *result*, `id`/`routeId`-keyed, non-nullable photo): this is a *read* item keyed by [deliveryId],
 * with a nullable [proofPhotoUrl] (freshly re-signed by the backend, may be absent) and a nullable
 * [comment] (failure reason for [DeliveryOutcome.Failed], optional note for [DeliveryOutcome.Completed]).
 */
data class DeliveryProofHistoryItem(
    val deliveryId: String,
    val status: DeliveryOutcome,
    /** ISO-8601 datetime. */
    val completedAt: String,
    val recipientName: String,
    val address: String,
    val proofPhotoUrl: String?,
    val comment: String?,
)
